<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentToVendor.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('paymentToVendor.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click="$router.push({ name: 'supplier-payment-create' })">
              {{
                $t('add_new')
              }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              style="width:200px" @change="fetchData()" />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input v-model="search" v-tooltip="$t('paymentToVendor.search')" :placeholder="$t('search')"
              style="width: 250px;" class="inline-block" />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('paymentToVendor.branch') }}</label>
                  <ts-branch-filter @filter="branchFilter" class="ts-w-full"></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :expandable="true" :rowGroup="{
          field: 'payment_date'
        }">
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td>{{ record.supplier ? record.supplier.vendor_name : '' }}</td>
            <td>{{ record.bill_number }}</td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ totalInvoice(record) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ totalAmountPaid(record) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ totalAmountDue(record) }}
            </td>
            <td>{{ record.payment_method.payment_method }}</td>
            <td>{{ record.next_payment_date }}</td>
            <td>{{ record.user ? record.user.name : '' }}</td>
            <td>{{ record.remarks }}</td>
            <td class="text-center ts-space-x-2 ts-whitespace-no-wrap">
              <a href="#" v-tooltip="$t('paymentToVendor.reprint')" class="text-primary text-red"
                @click.prevent="reprintReport(record)">
                <i class="fas fa-file-pdf"></i>
              </a>
              <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
                :cancel-text="$t('no')" @confirm="deleteRecord(record)">
                <a href="#" :disabled="record._deleting">
                  <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto detail">
              <thead>
                <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('paymentToVendor.stockInNumber') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('paymentToVendor.vendorInvoice') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('paymentToVendor.vendor') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-right">
                    {{ $t('paymentToVendor.billAmount') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-right">
                    {{ $t('paymentToVendor.amountPaid') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-right">
                    {{ $t('paymentToVendor.amountDue') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                    {{ $t('paymentToVendor.nextPayment') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="ts-border-b-2" v-for="(detail, index) in prop.record.children" :key="index">
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.stock_in_number }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.invoice_no }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.vendor_name }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap ts-text-right">
                    {{ $defaultCurrencyWithCode(parseFloat(detail.bill_amount, 2)) }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap ts-text-right">
                    {{ $defaultCurrencyWithCode(parseFloat(detail.amount_paid)) }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap ts-text-right">
                    {{
                      $defaultCurrencyWithCode(parseFloat(detail.amount_due))
                    }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap ts-text-center">
                    <span :class="detail.next_payment_date
                          ? 'ts-px-3 ts-rounded-md ts-bg-pink-600 ts-text-white ts-font-bold'
                          : ''
                        ">{{ detail.next_payment_date }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './reason_delete'

export default {
  name: 'payToVendorIndex',
  components: {
    Reason
  },
  data() {
    return {
      loading: false,
      showForm: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        deleted_reason: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('supplier/payment', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.supplier.payment.search
      },
      set(newValue) {
        this.$store.commit('supplier/payment/SET_SEARCH', newValue)
        this.$store.commit('supplier/payment/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.supplier.payment.dateRange
      },
      set(newValue) {
        this.$store.commit('supplier/payment/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('paymentToVendor.branchName') },
        { name: this.$t('paymentToVendor.vendor') },
        { name: this.$t('paymentToVendor.billNumber') },
        { name: this.$t('paymentToVendor.billAmount') },
        { name: this.$t('paymentToVendor.amountPaid') },
        { name: this.$t('paymentToVendor.amountDue') },
        { name: this.$t('paymentToVendor.paymentMethod') },
        { name: this.$t('paymentToVendor.nextPaymentDate') },
        { name: this.$t('paymentToVendor.approvedBy') },
        { name: this.$t('paymentToVendor.remarks') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('supplier/payment/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    totalInvoice(record) {
      let bill_amount = _.sumBy(record.children, 'bill_amount')
      if (bill_amount) {
        return this.$defaultCurrencyWithCode(_.round(bill_amount, 2))
      }
      return this.$defaultCurrencyWithCode(parseFloat(bill_amount))
    },
    totalAmountPaid(record) {
      let amount_paid = _.sumBy(record.children, 'amount_paid')
      if (amount_paid) {
        return this.$defaultCurrencyWithCode(_.round(amount_paid, 2))
      }

      return this.$defaultCurrencyWithCode(parseFloat(amount_paid))
    },
    totalAmountDue(record) {
      let amount_due = _.sumBy(record.children, 'amount_due')
      if (amount_due) {
        return this.$defaultCurrencyWithCode(_.round(amount_due, 2))
      }
      return this.$defaultCurrencyWithCode(parseFloat(amount_due))
    },
    addNew() {
      this.$router.push({ name: 'supplier-payment-create' })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('paymentToVendor.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store.dispatch('supplier/payment/destroy', {
            id: record.pay_tran_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() { }
      })
    },
    branchFilter(value) {
      this.$store.commit('supplier/payment/SET_BRANCH_ID', value)
      this.fetchData()
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('supplier/payment/toPdf', record.pay_tran_id)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('supplier/payment/RESET_STATE')
    next()
  }
}
</script>
